import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { ROUTES } from '../resources/routes-constants'
import { useNavigationTranslations } from '../hooks/useNavigationTranslations';

interface NotFoundPageProps {
  locale?: string;
}

const NotFoundPage: React.FC<NotFoundPageProps> = ({ locale: propLocale }) => {
    const navigate = useNavigate()
    const { translations: t, language, changeLanguage } = useNavigationTranslations();
    
    // Sync prop locale with hook if provided
    useEffect(() => {
        if (propLocale && propLocale !== language) {
            changeLanguage(propLocale);
        }
    }, [propLocale, language, changeLanguage]);

    /**
     * Call this function to redirect the user to the homepage.
     */
    const redirectToHomePage = () => {
        navigate(ROUTES.HOMEPAGE_ROUTE)
    }

    return (
        <div style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <h1 style={{ fontSize: '4em' }}>{t.navigations.notFound.title}</h1>
            <h1 style={{ fontSize: '4em' }}>{t.navigations.notFound.subtitle}</h1>
            <span style={{ cursor: 'pointer' }} onClick={() => redirectToHomePage()}>
                {t.navigations.notFound.homeLink}
            </span>
        </div>
    )
}

export default NotFoundPage
